// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__HFtp8","Logo":"Toolbar_Logo__22H4e","DesktopOnly":"Toolbar_DesktopOnly__3xArd"};